module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/instagram/chapel_sns_05-bedc1006b46d013965313ed22a2b4c3f.jpg";